import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=4fa5151e&scoped=true&"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js&"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5151e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fa5151e')) {
      api.createRecord('4fa5151e', component.options)
    } else {
      api.reload('4fa5151e', component.options)
    }
    module.hot.accept("./DesktopNavigation.vue?vue&type=template&id=4fa5151e&scoped=true&", function () {
      api.rerender('4fa5151e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Navigation/DesktopNavigation.vue"
export default component.exports